import axios from "axios";
// import { Token } from "../utils/localStorage.util";
// import config from "../config.js";

const apiRpa = axios.create({
  baseURL: "https://api-sped-rpa.taxationmind.com.br",
});

apiRpa.interceptors.request.use(
  async (config) => {
    // const token = Token.getToken();
    // if (token) {
    //   config.headers.Authorization = token;
    // }

    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiRpa.interceptors.response.use(
  (response) => {
    return response.data;
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export async function apiNoAr() {
  try {
    const response = await apiRpa.get(`/hello`);
    if (response.message == "Hello, World!") return true;
    else return false;
  } catch (error) {
    return false;
  }
}

export default apiRpa;
